import RoutePath from 'shared/utils/namedUrls';

const basePath = '/profile/';

export default {
  welcome: new RoutePath(`${basePath}welcome/`),
  wizardStart: new RoutePath(`${basePath}step/:slug/`),
  wizardCompleted: new RoutePath(`${basePath}completed/`),
};
